import type { FormAddressBase } from '@fv/client-types'
import type {
  LoadCustomsBroker as _CustomsBrokerDto,
  Country,
  Currency,
  CustomsBrokerType,
  ShipmentCustomsBrokerDto,
} from '@fv/models'
import type { DTO } from '@fv/models/core'

export const defaultFormBroker: FormCustomsBroker = {
  address: '',
  address2: '',
  city: '',
  companyName: '',
  country: 'us',
  email: '',
  phone: '',
  phoneExt: '',
  postalCode: '',
  state: '',
  value: '',
  valueCurrency: 'usd',
  type: '',
}

export interface FormCustomsBroker extends FormAddressBase {
  companyName: string
  email: string
  phone: string
  phoneExt: string
  value: string
  valueCurrency: Currency
  type: CustomsBrokerType | ''
  addressBookId?: string
}

export type CustomsBroker = Partial<
  Omit<FormCustomsBroker, 'country' | 'value' | 'type'>
> & {
  companyName: string
  country?: Country
  phone: string
  type?: CustomsBrokerType
  value?: number
  valueCurrency?: Currency
}

export type ShipmentCustomsBrokerFormModel = Omit<
  Required<ShipmentCustomsBrokerDto>,
  'type' | 'value' | 'valueCurrency'
> & {
  type: ShipmentCustomsBrokerDto['type'] | ''
  value: string
  valueCurrency: Currency
}

export const buildLoadCustomsBrokerDTO = (
  model: ShipmentCustomsBrokerFormModel,
): ShipmentCustomsBrokerDto => {
  return {
    ...model,
    type: model.type === '' ? undefined : model.type,
    ...(model.value && {
      value: parseFloat(model.value),
      valueCurrency: model.valueCurrency,
    }),
  }
}
export const buildShipmentCustomsBrokerFormModel = (
  broker: CustomsBroker,
): ShipmentCustomsBrokerFormModel => ({
  ...defaultFormBroker,
  ...broker,
  value: broker.value?.toString() || '',
  valueCurrency: broker.valueCurrency || 'usd',
})

export type CustomsBrokerDto = DTO<_CustomsBrokerDto>
